import { useNavigate } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface AccessRequiredDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Optional friendly name of the area the user tried to enter */
  area?: string;
}

export function AccessRequiredDialog({ open, onOpenChange, area }: AccessRequiredDialogProps) {
  const navigate = useNavigate();

  const go = (path: string) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10 border border-accent/30">
            <Lock className="h-5 w-5 text-accent" />
          </div>
          <DialogTitle className="text-center">
            {area ? `${area} requires contract access` : "Contract-based access required"}
          </DialogTitle>
          <DialogDescription className="text-center">
            Pharmalify Spine access is provisioned to authorized company users only
            after a formal company contract. Request a private walkthrough to discuss
            your scope, validation package and contract details.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 mt-2">
          <Button
            onClick={() => go("/contact")}
            className="w-full justify-between gap-2"
          >
            <span className="flex items-center gap-2">
              <Sparkles className="h-4 w-4" />
              Request Walkthrough
            </span>
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            onClick={() => go("/contact")}
            className="w-full justify-between gap-2"
          >
            <span>Request Validation & Contract Details</span>
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>

        <DialogFooter className="sm:justify-center mt-2">
          <button
            onClick={() => onOpenChange(false)}
            className="text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            Maybe later
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
